import './App.css'
import Main from './components/main'
import Event from './components/events'
import Footer from './components/footer'
import './styles/events.css'
import './styles/footer.css'
import './styles/main.css'


function App() {
  return (
    <>
    
    <Main />
    <Event />
    <Footer />
    
    </>
  );
}

export default App;
